import { z } from 'zod';

import { Address } from '../Address';
import { InsuranceEscrowSetting, MortgageInsuranceEscrowSetting, TaxEscrowSetting } from '../loan/EscrowSetting';

const PayeeApi = z.object({
  name: z.string(),
  address: Address.optional(),
});

export const TaxEscrowSettingApi = TaxEscrowSetting.pick({
  type: true,
  escrowed: true,
  status: true,
  amount: true,
  updatedAt: true,
  dueDates: true,
  taxType: true,
  apn: true,
}).extend({ id: z.string(), propertyId: z.string(), payee: PayeeApi });

export const InsuranceEscrowSettingApi = InsuranceEscrowSetting.pick({
  type: true,
  escrowed: true,
  status: true,
  amount: true,
  coverageAmount: true,
  updatedAt: true,
  insuranceName: true,
  agentName: true,
  agentEmail: true,
  agentPhone: true,
  policyNumber: true,
  policyStartDate: true,
  policyEndDate: true,
  forcedPlacedFlag: true,
}).extend({ id: z.string(), propertyId: z.string(), payee: PayeeApi });

export const MortgageInsuranceEscrowSettingApi = MortgageInsuranceEscrowSetting.pick({
  type: true,
  escrowed: true,
  status: true,
  amount: true,
  updatedAt: true,
  mortgageInsuranceType: true,
  fhaProgramType: true,
  startDate: true,
  midpointDate: true,
  paymentCadence: true,
  certificateId: true,
  poolCertificateNumber: true,
  coveragePercent: true,
  isRefundable: true,
  isFinanced: true,
  renewalType: true,
  // cancellationDetails: true, // TODO: https://github.com/willowservicing/willow/issues/9413
}).extend({ id: z.string(), propertyId: z.string(), payee: PayeeApi });

export const EscrowSettingApi = z.discriminatedUnion('type', [
  TaxEscrowSettingApi,
  InsuranceEscrowSettingApi,
  MortgageInsuranceEscrowSettingApi,
]);
export type EscrowSettingApi = z.infer<typeof EscrowSettingApi>;
